var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferSyncArrows300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px/transfer_sync_arrows_300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.05 19.75C9.8872 19.75 8.0465 18.9974 6.52792 17.4923C5.00933 15.9871 4.25004 14.1564 4.25004 12V11.2192L2.40002 13.0692L1.34619 12.0154L5.00002 8.36155L8.65384 12.0154L7.60002 13.0692L5.74999 11.2192V12C5.74999 13.7372 6.36153 15.2131 7.58462 16.4279C8.8077 17.6426 10.2962 18.25 12.05 18.25C12.4641 18.25 12.8779 18.2048 13.2914 18.1144C13.7048 18.024 14.1083 17.8885 14.5019 17.7077L15.6269 18.8327C15.0641 19.1352 14.483 19.3637 13.8837 19.5182C13.2843 19.6727 12.6731 19.75 12.05 19.75ZM19 15.6384L15.3462 11.9846L16.4 10.9308L18.25 12.7808V12C18.25 10.2628 17.6385 8.78683 16.4154 7.57207C15.1923 6.35732 13.7039 5.74995 11.95 5.74995C11.5359 5.74995 11.1221 5.79514 10.7087 5.88553C10.2952 5.97591 9.89169 6.11148 9.49809 6.29225L8.37312 5.1673C8.93593 4.86473 9.51702 4.63621 10.1164 4.48173C10.7157 4.32724 11.327 4.25 11.95 4.25C14.1128 4.25 15.9535 5.00256 17.4721 6.50768C18.9907 8.01281 19.75 9.84358 19.75 12V12.7808L21.6 10.9308L22.6538 11.9846L19 15.6384Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferSyncArrows300);
export default __webpack_public_path__ + "static/media/transfer_sync_arrows_300.b31f908956f16426e7c0287d5127f131.svg";
export { ForwardRef as ReactComponent };